import {Alert} from "react-native";
import ThermalPrinterModule from "react-native-thermal-printer";
import IminPrinter from "./imin-printer.min"
import {getReceiptPaymentType} from "../../constants/converter";
import {priceFormatter} from "../numbers";


export const paymentTypes = {
    cash: "Készpénz",
    creditCard: "Bankkártya",
    temporary: "FIZETETLEN",
    vipBalance: "VIP egyenleg",
};

// TODO: Don't forget to add "new EscPosCharsetEncoding("Cp852", 6)" to "@happy-gastro/react-native-thermal-printer/android"
function isIPorMACAddress(string) {
    // Regular expressions for matching IP addresses and MAC addresses
    const ipRegex = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/;
    const macRegex = /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/;

    // Check if the string matches either IP address or MAC address regex
    if (ipRegex.test(string)) {
        return "IP";
    } else if (macRegex.test(string)) {
        return "MAC";
    } else {
        return "Neither IP nor MAC Address";
    }
}
export const getPrinterTestData = (printerData) => {
    return (
        "\n\n" +
        "[C]<font size='normal'>Nyomtató észlelve!</font>\n" +
        "[C]============================\n" +
        "[L]" +
        printerData.ip +
        "[R]Név: \n" +
        "[L]Port: " +
        printerData.port +
        "[R]Típus: \n" +
        "[C]\n\n\n\n\n\n\n\n\n\n\n[C]"
    );
};

export const getBigStatisticsData = (data, restaurant, user) => {
    const divider = "[C]-------------------\n";
    //const dateRow = "[C]\n" + "[L]" + new Date().toLocaleDateString() + "[R]" + new Date().toLocaleTimeString() + "\n" + "[L]<u>#" + order.orderCode + "</u>[R]<u>" + user.name.first[0] + " " + user.name.last + "</u>\n" + "[C]\n" + "[C]\n" + "[C]\n" + "[C]\n" + "[C]\n";

    const allOrders = [...data.orders].filter(
        (o) => o.status !== "cancelled" && !o.storno
    );

    const acceptedOrdersWithoutMap = allOrders.filter(
        (o) =>
            o.orderType !== "dineIn" ||
            (o.orderType === "dineIn" && o.status === "closed")
    );

    let acceptedOrders = [];
    acceptedOrdersWithoutMap.forEach((o) => {
        if (o.paymentTypes && o.paymentTypes.length > 0) {
            o.paymentTypes.forEach((pT, i) => {
                acceptedOrders.push({
                    ...o,
                    paymentType: pT.paymentType,
                    orderSum: o.paymentTypes.length === 1 || i === 0 ? o.orderSum : 0,
                    productsSum:
                        o.paymentTypes.length === 1 || i === 0 ? o.productsSum : 0,
                    tipAmount: o.paymentTypes.length === 1 || i === 0 ? o.tipAmount : 0,
                    serviceFeePrice:
                        o.paymentTypes.length === 1 || i === 0 ? o.serviceFeePrice : 0,
                    deliveryFee:
                        o.paymentTypes.length === 1 || i === 0 ? o.deliveryFee : 0,
                });
            });
        } else {
            acceptedOrders.push(o);
        }
    });

    const ordersSum = [...acceptedOrdersWithoutMap].reduce(
        (total, order) => order.orderSum + total,
        0
    );

    const stornoOrders = [...data.orders.filter((o) => o.storno)];
    const stornoSum = [...stornoOrders].reduce(
        (total, order) => +total + order.orderSum,
        0
    );

    const creditCardOrders = [...acceptedOrders].filter(
        (o) => o.paymentType === "creditCard" || o.paymentType === "szepCreditCard"
    );
    const woltCreditCardOrders = [...acceptedOrders].filter(
        (o) => o.paymentType === "creditCard" && o.orderFrom === "wolt"
    );
    const boltCreditCardOrders = [...acceptedOrders].filter(
        (o) => o.paymentType === "creditCard" && o.orderFrom === "bolt"
    );

    const phoneOrders = [...acceptedOrders].filter(
        (o) =>
            o.orderFrom === "phone" &&
            o.orderType !== "dineIn" &&
            o.orderType !== "takeAway"
    );
    const webshopOrders = [...acceptedOrders].filter(
        (o) => o.orderFrom === "webshop"
    );
    const serveeOrders = [...acceptedOrders].filter((o) => o.orderFrom === "app");
    const netpincerOrders = [...acceptedOrders].filter(
        (o) => o.orderFrom === "netpincer"
    );
    const falatozzOrders = [...acceptedOrders].filter(
        (o) => o.orderFrom === "falatozz"
    );
    const woltOrders = [...acceptedOrders].filter((o) => o.orderFrom === "wolt");
    const boltOrders = [...acceptedOrders].filter((o) => o.orderFrom === "bolt");

    const takeAwayOrders = [...acceptedOrders].filter(
        (o) => o.orderType === "takeAway"
    );
    const dineInOrders = [...acceptedOrders].filter(
        (o) => o.orderType === "dineIn"
    );
    const onlineOrders = [...acceptedOrders].filter(
        (o) => o.orderType === "online"
    );

    const takeAwayCreditCard = [...takeAwayOrders].filter(
        (o) => o.paymentType === "creditCard"
    );
    const takeAwayCash = [...takeAwayOrders].filter(
        (o) => o.paymentType === "cash"
    );

    // Dine in orders
    const dineInCreditCard = [...dineInOrders].filter(
        (o) => o.paymentType === "creditCard"
    );
    const dineInCash = [...dineInOrders].filter((o) => o.paymentType === "cash");

    const onlineCreditCard = [...onlineOrders].filter(
        (o) => o.paymentType === "creditCard"
    );
    const onlineCash = [...onlineOrders].filter((o) => o.paymentType === "cash");
    const orditOrders = [...acceptedOrders].filter(
        (o) => o.orderFrom === "ordit"
    );

    const falatozzCreditCard = falatozzOrders.filter(
        (o) => o.paymentType === "creditCard"
    );
    const falatozzCash = falatozzOrders.filter((o) => o.paymentType === "cash");
    const pendingOrders = allOrders.filter((o) => o.status === "preparing");

    const cashOrders = [...acceptedOrders].filter(
        (o) => o.paymentType === "cash"
    );
    const placeCreditCards = acceptedOrders.filter(
        (o) =>
            o.paymentType === "creditCard" &&
            o.orderFrom !== "wolt" &&
            o.orderFrom !== "netpincer" &&
            o.orderFrom !== "bolt" &&
            o.orderFrom !== "ordit" &&
            o.orderFrom !== "falatozz"
    );
    const platformOrders = [
        ...phoneOrders,
        ...webshopOrders,
        ...serveeOrders,
        ...netpincerOrders,
        ...falatozzOrders,
        ...woltOrders,
        ...boltOrders,
        ...takeAwayOrders,
        ...orditOrders,
    ];


    const header1 = "[C]<font size='big'>Forgalmi adatok</font>\n\n";
    const block1 =
        "[L]Termék forgalom:[R]" +
        priceFormatter(data.priceSummary.productsSum) +
        "\n" +
        "[L]Kedvezmények:[R]" +
        priceFormatter(data.priceSummary.discountsSum) +
        "\n" +
        "[L]Szervízdíj:[R]" +
        priceFormatter(data.priceSummary.serviceFeeSum) +
        "\n" +
        "[L]Szállítási díj:[R]" +
        priceFormatter(data.priceSummary.deliveryFeeSum) +
        "\n" +
        "[L]<b>Végösszeg:</b>[R]<b>" +
        priceFormatter(data.priceSummary.ordersSum) +
        "</b>\n";

    const header2 = "\n[C]<font size='big'>Áfa bontás</font>\n\n";
    const block2 =
        "[L]<font size='small'></font>[C]<font size='small'>Nettó</font>[R]<font size='small'><font size='small'>Bruttó</font>\n" +
        Object.keys(data.vatSummary.vat)
            .map(
                (vatKey) =>
                    "[L]<font size='small'>" +
                    vatKey +
                    "%[C]<font size='small'>" +
                    priceFormatter(data.vatSummary.net[vatKey]) +
                    "</font>[R]<font size='small'><b>" +
                    priceFormatter(data.vatSummary.gross[vatKey]) +
                    "</b></font>"
            )
            .join("\n") +
        "\n";

    const header3 = "\n[C]<font size='big'>Platformok</font>\n\n";
    const block3 =
        "[L]FoodOra:[R]" +
        priceFormatter([...netpincerOrders].reduce((a, b) => +a + b.orderSum, 0)) +
        "\n" +
        "[L]Wolt:[R]" +
        priceFormatter([...woltOrders].reduce((a, b) => +a + b.orderSum, 0)) +
        "\n" +
        "[L]Házhozszállítás:[R]" +
        priceFormatter([...onlineOrders].reduce((a, b) => +a + b.orderSum, 0)) +
        "\n" +
        "[L] -Bankkártya:[R]" +
        priceFormatter([...onlineCreditCard].reduce((a, b) => +a + b.orderSum, 0)) +
        "\n" +
        "[L] -Készpénz:[R]" +
        priceFormatter([...onlineCash].reduce((a, b) => +a + b.orderSum, 0)) +
        "\n" +
        "[L]Elvitelre:[R]" +
        priceFormatter([...takeAwayOrders].reduce((a, b) => +a + b.orderSum, 0)) +
        "\n" +
        "[L] -Bankkártya:[R]" +
        priceFormatter(
            [...takeAwayCreditCard].reduce((a, b) => +a + b.orderSum, 0)
        ) +
        "\n" +
        "[L] -Készpénz:[R]" +
        priceFormatter([...takeAwayCash].reduce((a, b) => +a + b.orderSum, 0)) +
        "\n" +
        "[L]Webshop:[R]" +
        priceFormatter([...webshopOrders].reduce((a, b) => +a + b.orderSum, 0)) +
        "\n" +
        "[L] -Bankkártya:[R]" +
        priceFormatter(
            [...webshopOrders]
                .filter((o) => o.paymentType === "creditCard")
                .reduce((a, b) => +a + b.orderSum, 0)
        ) +
        "\n" +
        "[L] -Készpénz:[R]" +
        priceFormatter(
            [...webshopOrders]
                .filter((o) => o.paymentType === "cash")
                .reduce((a, b) => +a + b.orderSum, 0)
        ) +
        "\n" +
        "[L]Telefon:[R]" +
        priceFormatter([...phoneOrders].reduce((a, b) => +a + b.orderSum, 0)) +
        "\n" +
        "[L] -Bankkártya:[R]" +
        priceFormatter(
            [...phoneOrders]
                .filter((o) => o.paymentType === "creditCard")
                .reduce((a, b) => +a + b.orderSum, 0)
        ) +
        "\n" +
        "[L] -Készpénz:[R]" +
        priceFormatter(
            [...phoneOrders]
                .filter((o) => o.paymentType === "cash")
                .reduce((a, b) => +a + b.orderSum, 0)
        ) +
        "\n" +
        "[L]<b>Összesen:</b>[R]<b>" +
        priceFormatter([...platformOrders].reduce((a, b) => +a + b.orderSum, 0)) +
        "</b>\n";

    const header4 = "\n[C]<font size='big'>Rendelés típusa</font>\n\n";
    const block4 =
        "[L]Házhozszállítás:     [C]" +
        onlineOrders.length +
        " db[R]" +
        priceFormatter(onlineOrders.reduce((a, b) => +a + b.orderSum, 0)) +
        "\n" +
        "[L] -Bankkártya:        [C]" +
        onlineCreditCard.length +
        " db[R]" +
        priceFormatter(onlineCreditCard.reduce((a, b) => +a + b.orderSum, 0)) +
        "\n" +
        "[L] -Készpénz:          [C]" +
        onlineCash.length +
        " db[R]" +
        priceFormatter(onlineCash.reduce((a, b) => +a + b.orderSum, 0)) +
        "\n" +
        "[L]Elvitelre:           [C]" +
        takeAwayOrders.length +
        " db[R]" +
        priceFormatter(takeAwayOrders.reduce((a, b) => +a + b.orderSum, 0)) +
        "\n" +
        "[L] -Bankkártya:        [C]" +
        takeAwayCreditCard.length +
        " db[R]" +
        priceFormatter(takeAwayCreditCard.reduce((a, b) => +a + b.orderSum, 0)) +
        "\n" +
        "[L] -Készpénz:          [C]" +
        takeAwayCash.length +
        " db[R]" +
        priceFormatter(takeAwayCash.reduce((a, b) => +a + b.orderSum, 0)) +
        "\n" +
        "[L]Helyben:             [C]" +
        dineInOrders.length +
        " db[R]" +
        priceFormatter(dineInOrders.reduce((a, b) => +a + b.orderSum, 0)) +
        "\n" +
        "[L] -Bankkártya:        [C]" +
        dineInCreditCard.length +
        " db[R]" +
        priceFormatter(dineInCreditCard.reduce((a, b) => +a + b.orderSum, 0)) +
        "\n" +
        "[L] -Készpénz:          [C]" +
        dineInCash.length +
        " db[R]" +
        priceFormatter(dineInCash.reduce((a, b) => +a + b.orderSum, 0)) +
        "\n" +
        "[L]<b>Összesen:</b>     [C]" +
        acceptedOrders.length +
        " db[R]<b>" +
        priceFormatter(acceptedOrders.reduce((a, b) => +a + b.orderSum, 0)) +
        "</b>\n";

    const header5 = "\n[C]<font size='big'>Fizetési mód szerint</font>\n\n";
    const block5 =
        "[L]Készpénz:            [R]" +
        priceFormatter(0) +
        "\n" +
        "[L]Bankkártya:          [R]" +
        priceFormatter(0) +
        "\n" +
        "[L]Üzlet bankkártya:    [R]" +
        priceFormatter(0) +
        "\n" +
        "[L]FoodOra bankkártya:  [R]" +
        priceFormatter(0) +
        "\n" +
        "[L]Wolt bankkártya:     [R]" +
        priceFormatter(0) +
        "\n" +
        "[L]Utalvány:            [R]" +
        priceFormatter(0) +
        "\n" +
        "[L]Kupon:               [R]" +
        priceFormatter(0) +
        "\n" +
        "[L]<b>Összesen:</b>     [R]<b>" +
        priceFormatter(0) +
        "</b>\n";

    const header6 = "\n[C]<font size='big'>Egyéb adatok</font>\n\n";
    const block6 =
        "[L]Tétel stornó:        [C]" +
        data.removedItems +
        " db    [R]" +
        priceFormatter(data.removedItemsPrice) +
        "\n" +
        "[L]Számla stornó:       [C]" +
        stornoOrders.length +
        " db    [R]" +
        priceFormatter(stornoSum) +
        "\n" +
        "[L]Összes nyugta:       [C]" +
        acceptedOrders.length +
        " db    [R]" +
        priceFormatter(acceptedOrders.reduce((a, b) => +a + b.orderSum, 0)) +
        "\n" +
        "[L]Vendég / Kosár érték:[C]" +
        acceptedOrders.length +
        " db    [R]" +
        priceFormatter(ordersSum / acceptedOrders.length) +
        "\n" +
        "[L]Függő rendelések:    [C]" +
        data.orders.filter((o) => o.status === "pending").length +
        " db    [R]" +
        priceFormatter(
            data.orders
                .filter((o) => o.status === "pending")
                .reduce((a, b) => +a + b.orderSum, 0)
        ) +
        "\n" +
        "[L]<b>Összesen:</b>     [C]" +
        acceptedOrders.length +
        " db    [R]<b>" +
        priceFormatter(0) +
        "</b>\n\n\n\n";

    return (
        header1 +
        block1 +
        header2 +
        block2 +
        header3 +
        block3 +
        header4 +
        block4 +
        header5 +
        block5 +
        header6 +
        block6 +
        divider
    );
};

export const getBigTerminalData = (order, restaurant, user) => {
    const fontSizes = restaurant.name === "Maharaja étterem" ? "big" : "big";

    const productRow = (item) => {


        const currentSize = (item.item && item.item.sizes) ? item?.item?.sizes?.find((_) => _._id === item.size) || item?.item?.sizes[0] : item?.sizes[0];

        console.log("Extrák száma:", item?.extras?.length);
        console.log("currentSize:", currentSize);

        return (
            "[L]<font size='" +
            fontSizes +
            "'>" +
            (item.amount || item.quantity || 1) +
            " x " +
            ((item.name.hu || item.name.en) || (item.item.name.hu || item.item.name.en)) +
            "<font size='" +
            fontSizes +
            "'>" + (item.comment || item.serveType || (item.comments && item.comments.length > 0) ? " " + (item.comment || item.comments.join(", ")) : "") +
            (" (" +
                (currentSize?.amount || "") +
                " " +
                (currentSize?.unit || "") +
                ")</font>") +
            (item?.extras?.length > 0
                ? "\n" +
                item?.extras
                    .map(
                        (e) =>
                            "[L]<font size='" +
                            fontSizes +
                            "'>    + " + (e.item.name.hu || e.item.name.en) +
                            "</font>"
                    )
                    .join("\n")
                : "") +
            "</font>" +
            "[C]----------------------\n"
        );
    };

    let addressRow = "";
    if (order.orderType === "online" && order.addressInfo) {
        if (
            order.addressInfo &&
            order.addressInfo.zip &&
            order.addressInfo.city &&
            order.addressInfo.address
        ) {
            addressRow = "[C]"+order.addressInfo.zip + " " + order.addressInfo.city;
            addressRow = addressRow + "\n" + order.addressInfo.address;
        } else {
            addressRow =
                order.addressInfo && order.addressInfo.address
                    ? "[C]"+order.addressInfo.address
                    : "";
        }
    } else {
        addressRow = "";
    }
    const divider = "[C]-------------------\n";

    const dateRow =
        "[C]\n" +
        "[L]" +
        new Date().toLocaleDateString() +
        "[R]" +
        new Date().toLocaleTimeString() +
        "\n" +
        "[L]<u>#" +
        order.orderCode +
        "</u>[R]<u>" +
        user?.name?.first +
        " " +
        user?.name?.last +
        "</u>\n" +
        "[C]\n" +
        "[C]\n" +
        "[C]\n" +
        "[C]\n" +
        "[C]\n";

    const footerBlock =
        "[C]\n\n\n[C]<font size='big'>#" +
        order.orderCode +
        "</font>\n" +
        "[C]<u><font size='" +
        (order.orderType === "online" ? "normal" : "big") +
        "'>" +
        (order.orderType === "takeAway" ? "Take Away" : "") +(order.orderType === "takeAway"
            ? "[C]\n\n[C]<font size='big'>" + getOrderFrom(order.orderFrom) + "</font>\n"
            : "") +
        (order.orderType === "online"
            ? "[C]\n\n[C]<font size='big'>" + getOrderFrom(order.orderFrom) + "</font>\n"
            : "") +
        (order.orderType === "dineIn" ? "Table: " + order.tableName : "") +
        (order.orderType === "online"
            ? "<b>" +
            (order?.userInfo?.name?.first || "") +
            " " +
            (order?.userInfo?.name?.last || "") +
            "</b>"
            : "") +
        "</font></u>\n" +
        (order.orderType === "online" && addressRow
            ? "[C]" + addressRow + "\n"
            : "");

    return (
        footerBlock +
        [...Array(21).keys()]
            .map((key) => {
                if (
                    [...order.items].filter(
                        (item) => item.round === key
                    ).length > 0
                ) {
                    return (
                        (key > 0 ? "\n[C]" + key + ". kör\n" : "\n") +
                        [...order.items]
                            .filter((item) => (item.round === key))
                            .map((item) => productRow(item))
                            .join("\n")
                    );
                }
            })
            .join("") +
        "\n" +
        divider +
        dateRow
    );
};

const getOrderType = (orderType, order = {}) => {
    switch (orderType) {
        case 'online':
            return (order?.userInfo?.name?.first || "") + " " + (order?.userInfo?.name?.last || "")
        case 'dineIn':
            return 'Asztal: ' + order.tableName
        case 'takeAway':
            return 'Elvitelre'
    }
}

const getOrderFrom = (orderFrom) => {
    if (orderFrom === 'wolt') return 'Wolt';
    if (orderFrom === 'foodpanda') return 'Foodora';
    if (orderFrom === 'foodPanda') return 'Foodora';
    if (orderFrom === 'foodora') return 'Foodora';
    if (orderFrom === 'netpincer') return 'Foodora';
    if (orderFrom === 'falatozz') return 'Falatozz.hu';
    if (orderFrom === 'ordit') return 'Ordit.hu';
    if (orderFrom === 'webshop') return 'Webshop';
    if (orderFrom === 'phone') return 'Telefon / Phone';
    return 'Elviteles / Take away'
}

function stringToBytes(str) {
    const bytes = [];
    for (let i = 0; i < str.length; ++i) {
        bytes.push(str.charCodeAt(i));
    }
    return bytes;
}

export const getSmallReceiptData = async (order, restaurant, restaurantPlace, user) => {
    const IminPrintInstance = new IminPrinter();

    //初始化连接
    IminPrintInstance.connect("SPI").then(async (isConnect) => {
        if (isConnect) {

            try {
                const printer = IminPrintInstance;
                //alert("Connected iMin Printer!")
                IminPrintInstance.initPrinter();
                IminPrintInstance.printAndFeedPaper(50)
                const _generateItemRow = (row) => {
                    //printer.setTextStyle(1)
                    let currentSize = row.item?.sizes?.find((_) => _._id === row.size);
                    if (!currentSize) {
                        currentSize = row?.item?.sizes[row.sizeIndex] || row?.item?.sizes[0];
                    }
                    let itemName = (row.item.name['hu'] || row.item.name['en']) + ((currentSize && currentSize.amount !== 1) ? " (" + currentSize.amount + "" + currentSize.unit + ")" : "");
                    printer.printColumnsText([(row.amount || row.quantity || 0) + "x", itemName, priceFormatter(row.remmotePrice || row.price)], [1, 5, 3], [0, 0, 2], [26, 26, 28], 460)

                    //printer.setTextStyle(0)
                    if (row.comment) {
                        printer.printColumnsText(["", '"' + row.comment + '"'], [1, 3], [0, 0], [26, 26], 460)
                    }
                    if (row.serveType) {
                        printer.printColumnsText(["", '"' + row.serveType + '"'], [1, 3], [0, 0], [26, 26], 460)
                    }
                    if (row.comments && row.comments.length > 0) {
                        printer.printColumnsText(["", '"' + row.comments.join(', ') + '"'], [1, 3], [0, 0], [26, 26], 460)
                    }
                    if (row.extras) {
                        row.extras.map((extra => {
                            printer.printColumnsText([" +", (extra.item.name.hu || extra.item.name.en)], [1, 3], [0, 0], [26, 26], 460)
                        }))
                    }
                }
                // Items
                const _generateItems = () => {
                    order.items.map((currentItem) => _generateItemRow(currentItem));
                    printer.setAlignment(2);
                    printer.printText("---------")
                    printer.setAlignment(0);
                    printer.printColumnsText(["Összesen:", priceFormatter(order.productsPrice)], [3, 2], [0, 2], [30, 30], 460)

                    if (order.serviceFeePrice > 0) printer.printColumnsText(["Szervízdíj:", priceFormatter(order.serviceFeePrice)], [3, 2], [0, 2], [30, 30], 460)
                    if (order.deliveryFee > 0) printer.printColumnsText(["Szállítás:", priceFormatter(order.deliveryFee)], [3, 2], [0, 2], [30, 30], 460)
                    if (order.discountPrice > 0) printer.printColumnsText(["Kedvezmény:", priceFormatter(order.discountPrice)], [3, 2], [0, 2], [30, 30], 460)

                    if (order.paymentTypes.length > 0) order.paymentTypes.map((paymentType) => printer.printColumnsText([getReceiptPaymentType(paymentType.paymentType) + ":", priceFormatter(paymentType.amount)], [3, 2], [0, 2], [30, 30], 460))


                    if (order.paymentTypes.length === 0) {
                        if (order.paymentType === "temporary") printer.printColumnsText(["Fizetendő:", priceFormatter(order.orderSum)], [3, 2], [0, 2], [30, 30], 460)
                        if (order.paymentType !== "temporary") printer.printColumnsText([getReceiptPaymentType(order.paymentType) + ":", priceFormatter(order.orderSum)], [3, 2], [0, 2], [30, 30], 460)
                    }
                }
                // Header
                const _generateHeader = () => {
                    //printer.printSingleBitmap(restaurant.logo)
                    printer.setAlignment(1);
                    printer.setTextStyle(1);
                    printer.setTextSize(45);
                    printer.printText(restaurant.name);
                    printer.setTextStyle(0);
                    printer.setTextSize(26);
                    printer.printText(restaurantPlace.contact.phone || restaurant.contact.phone || "");
                    if (restaurantPlace.raw) printer.printText(restaurantPlace.raw || "");
                    printer.setTextSize(26);
                    printer.printText("------------------------------------")
                    printer.setTextSize(38);
                    printer.setTextStyle(1);
                    printer.printText("#" + (order.orderCode || "123-456"));
                    printer.setTextSize(26);

                    printer.setAlignment(1);

                    printer.setTextSize(30);
                    printer.printText(getOrderType(order.orderType || 'takeAway', order));
                    if (order.orderType === 'online') {
                        printer.setTextSize(26);

                        if (order.userInfo && order.userInfo.name && order.userInfo.name.first) printer.printText((order.userInfo.name.first || "") + " " + (order.userInfo.name.last || ""));
                        if (order.userInfo && order.userInfo.phone) printer.printText(order.userInfo.phone);

                        if (order.addressInfo && order.addressInfo.zip && order.addressInfo.city && order.addressInfo.address) {
                            printer.printText(order.addressInfo.zip + " " + order.addressInfo.city);
                            printer.printText(order.addressInfo.address)
                        } else {
                            printer.printText(order.addressInfo && order.addressInfo.address ? order.addressInfo.address : "");
                        }
                        if (order.addressInfo.other && order.addressInfo.other.info) printer.printText(order.addressInfo.other.info);
                    }

                    printer.setAlignment(1);
                    printer.setTextSize(26);
                    printer.setTextStyle(1);
                    if (order.comments && order.comments.length > 0) printer.printText('"' + order.comments.join(', ') + '"');
                    if (order.comment) printer.printText('"' + order.comment + '"');

                    printer.setTextSize(26);
                    //IminPrintInstance.setTextLineSpacing('1.0f');
                }
                _generateHeader();
                printer.printText("------------------------------------")
                _generateItems();
                IminPrintInstance.printAndFeedPaper(40)
                printer.setAlignment(1);
                printer.setTextSize(23);
                printer.setTextStyle(1);
                printer.printText("Köszönjük, hogy a vendégünk volt!")
                printer.setTextSize(22);
                printer.setTextStyle(0);
                printer.printText("KÉSZPÉNZ ÁTVÉTELRE NEM JOGOSÍT!")
                printer.printText("NOT VALID FOR CASH PAYMENT!")
                printer.setTextSize(20);
                printer.printText("Üzemelteti a Happy Gastro™ Éttermi szoftver")
                printer.printText("www.happygastro.hu")
                printer.printAndFeedPaper(100)
            } catch (e) {
                Alert.alert("Sikertelen nyomtatás!", "A számla nyomtatása nem sikerült!");
                console.error("Print receipt error:", e)
                getSmallReceiptData(order, restaurant, restaurantPlace)
            }
        }
    });
}
export const getBigReceiptData = (order, restaurant, restaurantPlace, user) => {

    const getPaymentType = (paymentType, paymentNonce) => {
        if (order.paymentType === "creditCard") {
            if (
                order.orderFrom === "netpincer" ||
                order.orderFrom === "wolt" ||
                order.orderFrom === "bolt" ||
                order.orderFrom === "ordit" ||
                order.orderFrom === "falatozz"
            ) {
                return "FIZETVE!";
            }
            if (paymentType === "szepCreditCard" && !paymentNonce)
                return "Szép kártya / Bankkártya futárnál";
            if (paymentType === "creditCard" && paymentNonce) return "FIZETVE!";
            return paymentTypes[order.paymentType];
        }
        return paymentTypes[order.paymentType];
    };

    let addressRow = "";
    if (order.orderType === "online" && order.addressInfo) {
        if (
            order.addressInfo &&
            order.addressInfo.zip &&
            order.addressInfo.city &&
            order.addressInfo.address
        ) {
            addressRow = order.addressInfo.zip + " " + order.addressInfo.city;
            addressRow = addressRow + "\n" + order.addressInfo.address;
        } else {
            addressRow = order.addressInfo && order.addressInfo.address ? order.addressInfo.address : "";
        }
    }

    const divider = "[C]------------------------------------------\n";

    const header =
        ((order.orderType === "online" && order.userInfo && order.userInfo.name)
            ? "[C]<font size='big' color='black'>" +
            (order?.userInfo?.name?.first || "") +
            " " +
            (order?.userInfo?.name?.last || "") +
            "</font>\n"
            : "") +
        ((order.orderType === "online" && addressRow)
            ? "[C]" + addressRow + "\n"
            : "") +
        ((order.orderType === "online" && order.userInfo && (order.userInfo.mobilePhone || order.userInfo.phone))
            ? "[C]Telefon: " +
            (order.userInfo.mobilePhone || order.userInfo.phone) +
            "\n"
            : "") +
        (order.orderType === "online" && order.comments && order.comments.length > 0
            ? '[C]"' + [...order.comments].join(", ") + '"\n'
            : "") +
        (order.orderType === "online" && order.comment
            ? '[C]"' + order.comment + '"\n'
            : "") +
        (order.orderType === "online"
            ? "\n[C]<font size='big' color='bg-black'>" +
            getPaymentType(order.paymentType, order.paymentNonce) +
            "</font>\n\n"
            : "") +
        "[C]<font size='big' color='black'>" +
        restaurant?.name +
        "</font>\n" +
        "[C]<font size='normal'>" +
        restaurantPlace?.raw +
        "</font>\n" +
        "[C]\n" +
        "[C]=========================================\n" +
        "[C]Kérdés és panasz esetén értesítendő:\n" +
        "[C]" +
        restaurantPlace?.contact?.phone +
        "\n" +
        "[C]=========================================\n" +
        "[C]\n";

    const productRow = (item) => {
        const currentSize = item?.item?.sizes.find((_) => _._id === item.size);
        return (
            "[L]<font size='normal'>" +
            (item.amount || item.quantity || 1) +
            " x " +
            (item.remoteName || item.item.name.hu || item.item.name.en) +
            "[R]" +
            priceFormatter(
                (item.amount || item.quantity || 1) * (item.remotePrice || item.price)
            ) +
            "\n   " +
            currentSize.amount +
            " " +
            currentSize.unit +
            " / " +
            priceFormatter(item.remotePrice || item.price) +
            (item.extras.length > 0
                ? "\n" +
                "\n" +
                item.extras
                    .map(
                        (e) =>
                            "[L]<font size='normal'>    + " +
                            (e.item.name.hu || e.item.name.en) +
                            (e.price !== undefined ? " (" + priceFormatter(e.remotePrice || e.price) + ")" : "") +
                            "</font>"
                    )
                    ?.join("\n")
                : "") +
            "</font>"
        );
    };

    const productsSum =
        "[L]Termék(ek) összesen :[R]" +
        priceFormatter(
            (order.orderSum || 0) - order.serviceFeePrice - order.deliveryFee
        ) +
        "\n";

    const discountsRow =
        !order.discounts || order.discounts.amount === 0
            ? ""
            : "[L]<b>Kedvezmény :</b>[R]<b>" +
            priceFormatter(order.discounts.amount) +
            "</b>\n";

    const discountsRowPercentage =
        !order.discounts || order.discounts.percentage === 0
            ? ""
            : "[L]<b>Kedvezmény (" +
            order.discounts.percentage +
            "%) :</b>[R]<b>" +
            priceFormatter(0) +
            "</b>\n";

    const deliveryFee =
        !order.deliveryFee || order.deliveryFee === 0
            ? ""
            : "[L]<b>Szállítási díj :</b>[R]<b>" +
            priceFormatter(order.deliveryFee) +
            "</b>\n";

    const serviceFee =
        order.serviceFeePrice === 0
            ? ""
            : "[L]<b>Szervízdíj (" +
            order.serviceFee +
            "%) :</b>[R]<b>" +
            priceFormatter(order.serviceFeePrice) +
            "</b>\n";

    const orderSumRow =
        "[L]<font size='normal'><b>Végösszeg :</b></font>[R]<font size='normal'><b>" +
        priceFormatter(order.orderSum || 0) +
        "</b></font>\n\n";

    const paymentType =
        "[L]" +
        paymentTypes[order.paymentType] +
        ":[R]" +
        priceFormatter(order.orderSum || 0) +
        "\n";

    //const vatTable = !order.vatSum ? '' : '[L]\n[L]\n[L]<font size="small"></font>[R]<font size="small">Nettó</font>[R]<font size="small">Áfa</font>[R]Bruttó\n' + order.vatSum?.map(vat => ("[L]<font size='small'>Áfa (" + vat + "%)</font>[R]<font size='small'>" + priceFormatter(order.netSum[vat]) + "</font>[R]<font size='small'>" + priceFormatter(order.vatSum[vat]) + "</font>[R]<font size='small'>" + priceFormatter(order.grossSum[vat]) + "</font>\n")) + '[C]\n';

    const dateRow =
        "[C]\n" +
        "[L]" +
        new Date().toLocaleTimeString() +
        "[R]" +
        new Date().toLocaleDateString() +
        "\n" +
        "[C]\n";

    const footerBlock =
        "[C]<font size='normal'>Rendelés száma:</font>\n" +
        "[C]<u><font size='big'>#" +
        order.orderCode +
        "</font></u>\n\n\n" +
        "[C]<font size='normal'>Happy Solutions</font>\n" +
        "[C]<u><font size='normal'>www.happysolutions.hu</font></u>\n\n" +
        "[C]<font size='normal'>Köszönjük, hogy a vendégünk volt!</font>\n" +
        "\n" +
        "[C]<font size='small'><b>KÉSZPÉNZ ÁTVÉTELRE NEM JOGOSÍT!</b></font>\n" +
        "[C]<font size='small'><b>NOT VALID FOR CASH PAYMENT!</b></font>\n" +
        "[C]\n" +
        "[C]\n" +
        "[C]\n";

    return (
        header +
        order.items?.map((item) => productRow(item)).join("\n") +
        "\n" +
        divider +
        productsSum +
        serviceFee +
        deliveryFee +
        discountsRow +
        discountsRowPercentage +
        orderSumRow +
        dateRow +
        paymentType +
        divider +
        footerBlock
    );
};

export const sendPrinter = async (data, printer) => {

    // return true;
    if (printer.ip && printer.ip !== "" && isIPorMACAddress(printer.ip) === "IP") {
        return ThermalPrinterModule.printTcp({
            ...ThermalPrinterModule.defaultConfig,
            timeout: 1500,
            ...printer,
            printerDpi: 203,
            printerWidthMM: 80,
            printerNbrCharactersPerLine: 42,
            payload: data,
            charset: 'Cp852',
            encodingId: 0
        })
            .then((response) => {
                console.log("Data printed by TCP/IP!");
                return true;
            })
            .catch((error) => {
                Alert.alert(
                    "Hiba történt nyomtatás közben:",
                    error.message + " (" + printer.ip + ")",
                    [
                        {
                            text: 'Mégsem',
                            onPress: () => Alert.alert('Cancel Pressed'),
                            style: 'cancel',
                        },
                        {
                            text: 'Újrapróbálkozás',
                            onPress: () => sendPrinter(data, printer),
                            style: 'default',
                        },
                    ],
                );
            });
    } else if ((printer.address && printer.address !== "") || isIPorMACAddress(printer.ip) === "MAC") {
        return ThermalPrinterModule.printBluetooth({
            ...ThermalPrinterModule.defaultConfig,
            ...printer,
            ip: undefined,
            port: undefined,
            macAddress: printer.ip,
            payload: data,
            charset: 'Cp437',
            encodingId: 6
        })
            .then((response) => {
                console.log("Data printed by Bluetooth!");
                return true;
            })
            .catch((error) => {
                console.error('Bluetooth print error:', error)
                Alert.alert(
                    "Hiba történt nyomtatás közben:",
                    error.message + " (" + printer.ip + ")",
                    [
                        {
                            text: 'Mégsem',
                            onPress: () => Alert.alert('Cancel Pressed'),
                            style: 'cancel',
                        },
                        {
                            text: 'Újrapróbálkozás',
                            onPress: () => sendPrinter(data, printer),
                            style: 'default',
                        },
                    ],
                );
                return false;
            });
    } else {
    }
};

//import { spawnThread } from 'react-native-multithreading';

export const startBackgroundTask = (action) => {
    action();
};
